import aviaoPremiacao from 'assets/img/2026/aviao_premiacao.png';
import cartaoPremiacao from 'assets/img/2026/cartao_premiacao.png';
import avisoInscricao from 'assets/img/2026/ELBB/aviso_inscricao.png';
import navesHome from 'assets/img/2026/naves_home.png';
import { OnboardingModal } from 'components/OnboardingModal';
import { VotacaoEtapa1TutorialModal } from 'components/VotacaoEtapa1TutorialModal';
import { VotacaoEtapa2TutorialModal } from 'components/VotacaoEtapa2TutorialModal';
import { VotacaoEtapa3TutorialModal } from 'components/VotacaoEtapa3TutorialModal';
import { useAuth } from 'context/AuthContext';
import { useModal } from 'context/ModalContext/Modal.context';
import { useActivePhases, useIsDateActive, usePeriodoFase } from 'hooks/useControlDate';
import { useCronograma } from 'hooks/useCronograma';
import { formatarPeriodo } from 'utils/cronograma';
import { useGanhouPremio } from 'hooks/useGanhouPremio';
import { useSituacaoPreInscricao } from 'hooks/useSituacaoPreInscricao';
import { NotificationPopup } from 'components/ui/NotificationPopup';
import { PreInscricaoNotification } from 'components/PreInscricaoNotification';
import { useEffect, useRef, useState, type MouseEvent } from 'react';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { fetchMinhasAvaliacoesEtapa2 } from 'services/avaliacao-etapa2.service';
import { fetchChallengesWithStatus } from 'services/challenge.service';
import { buscarComunicados } from 'services/comunicado.service';
import { buscarIndicacoesExistentes, isIniciativaExecutivoOnly } from 'services/indicacao-ge.service';
import { buscarIniciativas, buscarIniciativasPorPlayer } from 'services/iniciativa.service';
import { hasVinculoIniciativaInscritaPremio } from 'services/minhas-iniciativas-eligibility.service';
import { fetchCategoriasCompletadas } from 'services/selecao-etapa1.service';
import { fetchTodasSelecoesByUser } from 'services/selecao-etapa3.service';
import { getTutorial, getTutorialByTitle } from 'services/tutorial.service';
import {
  buscarValidacaoEtapa1PorPrefixo,
  getIdentifierFromPlayerFields,
  hasEtapa1Eligibility,
} from 'services/validacao-etapa1.service';
import {
  fetchPreliminarEmAprovacaoByVp,
  fetchUltimoPreliminarByAssessor,
} from 'services/voto-preliminar-etapa3.service';
import { getTutorialEtapa3IdForUser, isAssessorEtapa3, isVpEtapa3 } from 'types/etapa3';
import { Tutorial } from 'types/tutorial';
import { PHASE_IDS } from 'utils/constants';
import {
  filterIniciativasByCategoria,
  getCategoriasVotacao,
} from 'utils/etapa1-categoria-map';
import { clearRegistrationUser } from 'utils/fns';
import { preloadImagesFromHtmlBlocks } from 'utils/html-content';
import {
  CATEGORIAS_PARTICIPANTES,
  CategoriasParticipantes,
  isPreliminarConexao,
} from './components/CategoriasParticipantes';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Timeline } from './components/Timeline';
import './style.scss';

const CHALLENGE_ID_VOTAR_INICIATIVAS = 'FohR25H';
const CHALLENGE_TITULO_VOTAR_INICIATIVAS = 'Vote nas iniciativas';

// Vídeo das experiências do Prêmio BB, exibido em modal ao clicar no botão do card do avião.
const EXPERIENCIAS_VIDEO_URL =
  'https://funifier.s3.us-east-1.amazonaws.com/premio-bb/BB_EVENTO_PREMIO_FINAL.mp4';

const normalizeMatricula = (value?: string | null) => clearRegistrationUser(String(value || ''));

const isUsuarioConfirmadoNaIniciativa = (ini: any, currentUserRegistration: string) => {
  if (!currentUserRegistration) {
    return false;
  }

  const participanteAtual = Array.isArray(ini?.participantes)
    ? ini.participantes.find(
        (participante: any) =>
          normalizeMatricula(participante?.matricula) === currentUserRegistration
      )
    : undefined;

  const isParticipanteConfirmadoNoModal = Boolean(participanteAtual?.confirmado);

  const isConfirmadoEmConfirmedPlayers = Array.isArray(ini?.confirmedPlayers)
    ? ini.confirmedPlayers.some(
        (confirmedPlayerId: string) =>
          normalizeMatricula(confirmedPlayerId) === currentUserRegistration
      )
    : false;

  return isParticipanteConfirmadoNoModal || isConfirmadoEmConfirmedPlayers;
};

export function HomePublic() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { showModal, closeModal } = useModal();
  const [badges, setBadges] = useState<any[]>([]);
  const [hasConquistaVotar, setHasConquistaVotar] = useState(false);
  const [iniciativas, setIniciativas] = useState<any[]>([]);
  const [comunicados, setComunicados] = useState<any[]>([]);
  const [tutorial, setTutorial] = useState<Tutorial | null>(null);
  const [tutorialEtapa1, setTutorialEtapa1] = useState<Tutorial | null>(null);
  const [tutorialEtapa2, setTutorialEtapa2] = useState<Tutorial | null>(null);
  const [tutorialEtapa3, setTutorialEtapa3] = useState<Tutorial | null>(null);
  const [stepAtivo, setStepAtivo] = useState(0);
  const [isCarouselPaused, setIsCarouselPaused] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [loadingBadges, setLoadingBadges] = useState(true);
  const [loadingIniciativas, setLoadingIniciativas] = useState(true);
  const [loadingComunicados, setLoadingComunicados] = useState(true);
  const [temIniciativasParaInscrever, setTemIniciativasParaInscrever] = useState(false);
  const [temIniciativasParaConfirmar, setTemIniciativasParaConfirmar] = useState(false);
  const [isParticipanteConfirmado, setIsParticipanteConfirmado] = useState(false);
  const isInscricaoAtiva = useIsDateActive(PHASE_IDS.CONEXAO_REGISTRATION_PERIOD);
  const [canAccessMinhasIniciativas, setCanAccessMinhasIniciativas] = useState(false);
  const [todasCategoriasEtapa1Completas, setTodasCategoriasEtapa1Completas] = useState(false);
  const [temIniciativasEtapa1, setTemIniciativasEtapa1] = useState(false);
  const badgesSectionRef = useRef<HTMLElement | null>(null);
  const isElegivelEtapa1 = hasEtapa1Eligibility(user?.detail);
  const [temIndicacoesPendentesGE, setTemIndicacoesPendentesGE] = useState(false);
  const [jaVotouTodasCategoriasEtapa2, setJaVotouTodasCategoriasEtapa2] = useState(false);
  const [jaVotouTodasCategoriasEtapa3, setJaVotouTodasCategoriasEtapa3] = useState(false);
  const [temVotoEtapa3Submetido, setTemVotoEtapa3Submetido] = useState(false);
  const [assessorEnviouPreliminar, setAssessorEnviouPreliminar] = useState(false);
  const [assessorPreliminarSuperseded, setAssessorPreliminarSuperseded] = useState(false);
  const [vpTemPreliminarPendente, setVpTemPreliminarPendente] = useState(false);
  const [extratoPopupOpen, setExtratoPopupOpen] = useState(true);
  const { ganhou: ganhouPremio } = useGanhouPremio();
  const situacaoPreInscricao = useSituacaoPreInscricao();
  const etapasCronograma = useCronograma();
  const phases = useActivePhases();
  const isEtapaUmVotacaoAtiva = phases.etapa1premio;
  const datasEtapa2Label = formatarPeriodo(usePeriodoFase(PHASE_IDS.ETAPA_2_PREMIO));
  const datasEtapa3Label = formatarPeriodo(usePeriodoFase(PHASE_IDS.ETAPA_3_PREMIO));
  const isElegivelEtapa3 = Number(user?.extra?.etapa) === 3;
  const isAssessor = isAssessorEtapa3(user ?? null);
  const isVp = isVpEtapa3(user ?? null);
  const assessorJaEnviou =
    isAssessor && (assessorEnviouPreliminar || assessorPreliminarSuperseded);

  const getInscricaoTimestamp = (iniciativa: any): number => {
    const source = iniciativa?.iniciativaOriginal || iniciativa;
    const dateValue = source?.dt_inscricao || source?.updatedAt;

    if (!dateValue) return 0;
    const parsed = new Date(dateValue).getTime();
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  useEffect(() => {
    async function loadBadges() {
      if (!user?._id) return;

      try {
        setLoadingBadges(true);
        const challengesData = await fetchChallengesWithStatus(user._id, { user });

        const conquistouVotar = challengesData.some(
          (challenge) =>
            challenge.concluida &&
            (challenge.id === CHALLENGE_ID_VOTAR_INICIATIVAS ||
              challenge.titulo === CHALLENGE_TITULO_VOTAR_INICIATIVAS)
        );
        setHasConquistaVotar(conquistouVotar);

        const sortedChallenges = [...challengesData].sort((a, b) => {
          if (a.concluida && !b.concluida) return -1;
          if (!a.concluida && b.concluida) return 1;
          return 0;
        });

        const badgesData = sortedChallenges.slice(0, 5).map(challenge => ({
          id: challenge.id,
          nome: challenge.titulo,
          imagem: challenge.icone,
          conquistado: challenge.concluida
        }));

        setBadges(badgesData);
      } catch (error) {
        console.error('Erro ao carregar badges:', error);
        setHasConquistaVotar(false);
      } finally {
        setLoadingBadges(false);
      }
    }

    loadBadges();
  }, [user]);

  useEffect(() => {
    if (!user?._id) return;

    async function verificarIniciativasPlayer() {
      try {
        const conexaoCompleta = await buscarIniciativasPorPlayer(user!._id);
        const conexao = conexaoCompleta.filter(
          (ini: any) => !isIniciativaExecutivoOnly(ini?.iniciativaOriginal, user!._id)
        );
        const currentUserRegistration = normalizeMatricula(user?._id);
        const confirmadoEmAlgumaIniciativa = conexao.some((ini: any) =>
          isUsuarioConfirmadoNaIniciativa(ini, currentUserRegistration)
        );

        const possuiIniciativaParaInscrever = conexao.some((ini: any) => {
          const status = String(ini?.status || '').toLowerCase();
          return status !== 'inscrita';
        });

        const possuiIniciativaParaConfirmar = conexao.some((ini: any) => {
          const status = String(ini?.status || '').toLowerCase();
          const jaConfirmadoNessaIniciativa = isUsuarioConfirmadoNaIniciativa(
            ini,
            currentUserRegistration
          );
          return status === 'inscrita' && !jaConfirmadoNessaIniciativa;
        });

        const possuiVinculoInscritoPremio = hasVinculoIniciativaInscritaPremio(conexao);

        setTemIniciativasParaInscrever(possuiIniciativaParaInscrever);
        setTemIniciativasParaConfirmar(possuiIniciativaParaConfirmar);
        setIsParticipanteConfirmado(confirmadoEmAlgumaIniciativa);
        setCanAccessMinhasIniciativas(possuiVinculoInscritoPremio);
      } catch {
        setTemIniciativasParaInscrever(false);
        setTemIniciativasParaConfirmar(false);
        setIsParticipanteConfirmado(false);
        setCanAccessMinhasIniciativas(false);
      }
    }

    verificarIniciativasPlayer();
  }, [user?._id]);

  // Verificar se GE tem indicacoes pendentes
  useEffect(() => {
    if (!user?._id) return;

    async function verificarIndicacoesGE() {
      try {
        const todas = await buscarIniciativasPorPlayer(user!._id);
        const iniciativasGE = todas.filter(
          (ini) =>
            ini.status === 'inscrita' &&
            isIniciativaExecutivoOnly(ini.iniciativaOriginal, user!._id) &&
            (ini.participantes?.length || 0) > 5,
        );
        if (iniciativasGE.length === 0) {
          setTemIndicacoesPendentesGE(false);
          return;
        }

        const ids = iniciativasGE.map((ini) => ini.id);
        const indicacoesMap = await buscarIndicacoesExistentes(ids);
        const temPendentes = iniciativasGE.some((ini) => !indicacoesMap.has(ini.id));
        setTemIndicacoesPendentesGE(temPendentes);
      } catch {
        setTemIndicacoesPendentesGE(false);
      }
    }

    verificarIndicacoesGE();
  }, [user?._id]);

  useEffect(() => {
    async function carregarIniciativas() {
      try {
        setLoadingIniciativas(true);
        const iniciativasConexao = await buscarIniciativas({
          userId: user?._id
        });

        const iniciativasOrdenadasPorInscricao = iniciativasConexao
          .filter((ini: any) => ini.status === 'inscrita')
          .sort((a: any, b: any) => getInscricaoTimestamp(b) - getInscricaoTimestamp(a));

        setIniciativas(iniciativasOrdenadasPorInscricao || []);
      } catch (error) {
        setIniciativas([]);
      } finally {
        setLoadingIniciativas(false);
      }
    }

    if (user?._id) {
      carregarIniciativas();
    }
  }, [user?._id]);

  useEffect(() => {
    async function carregarComunicados() {
      try {
        setLoadingComunicados(true);
        const data = await buscarComunicados();
        setComunicados(data || []);
      } catch (error) {
        console.error('Erro ao carregar comunicados:', error);
        setComunicados([]);
      } finally {
        setLoadingComunicados(false);
      }
    }

    carregarComunicados();
  }, []);

  useEffect(() => {
    const htmlBlocks = comunicados.flatMap((comunicado: any) =>
      Array.isArray(comunicado?.steps)
        ? comunicado.steps.map((step: any) => step?.text || '')
        : []
    );

    if (htmlBlocks.length > 0) {
      preloadImagesFromHtmlBlocks(htmlBlocks);
    }
  }, [comunicados]);

  useEffect(() => {
    async function carregarTutorial() {
      try {
        const [tutorialConexao, tutorialEtapa1Api] = await Promise.all([
          getTutorialByTitle('CONEXAO'),
          getTutorialByTitle('TUTORIAL_ETAPA1')
        ]);

        if (tutorialConexao) {
          setTutorial(tutorialConexao);
        }

        if (tutorialEtapa1Api) {
          setTutorialEtapa1(tutorialEtapa1Api);
        }
      } catch (error) {
        console.error('Erro ao carregar tutorial:', error);
      }
    }

    carregarTutorial();
  }, []);

  useEffect(() => {
    let canceled = false;
    if (user?.extra?.etapa !== 2) return;
    getTutorialByTitle('TUTORIAL_ETAPA2')
      .then((t) => {
        if (!canceled) setTutorialEtapa2(t);
      })
      .catch(() => {
        if (!canceled) setTutorialEtapa2(null);
      });
    return () => {
      canceled = true;
    };
  }, [user?.extra?.etapa]);

  useEffect(() => {
    let canceled = false;
    if (!user?._id) return;
    getTutorial(getTutorialEtapa3IdForUser(user))
      .then((t) => { if (!canceled) setTutorialEtapa3(t ?? null); })
      .catch(() => { if (!canceled) setTutorialEtapa3(null); });
    return () => { canceled = true; };
  }, [user?._id]);

  useEffect(() => {
    let canceled = false;
    const categorias = user?.extra?.categories ?? [];
    if (!user?._id || user.extra?.etapa !== 2 || categorias.length === 0) {
      setJaVotouTodasCategoriasEtapa2(false);
      return;
    }
    fetchMinhasAvaliacoesEtapa2(user._id)
      .then((avaliacoes) => {
        if (canceled) return;
        const votadas = new Set(avaliacoes.map((a) => a.category));
        setJaVotouTodasCategoriasEtapa2(categorias.every((c) => votadas.has(c)));
      })
      .catch(() => {
        if (!canceled) setJaVotouTodasCategoriasEtapa2(false);
      });
    return () => {
      canceled = true;
    };
  }, [user?._id, user?.extra?.etapa, user?.extra?.categories]);

  useEffect(() => {
    let canceled = false;
    if (!user?._id) {
      setJaVotouTodasCategoriasEtapa3(false);
      setTemVotoEtapa3Submetido(false);
      return;
    }
    fetchTodasSelecoesByUser(user._id)
      .then((selecoes) => {
        if (canceled) return;
        // Ignora votos ELBB (exclusivos da branch ELBB) e considera apenas
        // votos com pelo menos uma iniciativa registrada.
        const selecoesConexao = selecoes.filter(
          (s) => s.categoria !== 'ELBB' && (s.iniciativaIds?.length ?? 0) > 0
        );
        const votadas = new Set(selecoesConexao.map((s) => s.categoria));
        setJaVotouTodasCategoriasEtapa3(
          CATEGORIAS_PARTICIPANTES.every((c) => votadas.has(c.id))
        );
        setTemVotoEtapa3Submetido(selecoesConexao.length > 0);
      })
      .catch(() => {
        if (!canceled) {
          setJaVotouTodasCategoriasEtapa3(false);
          setTemVotoEtapa3Submetido(false);
        }
      });
    return () => {
      canceled = true;
    };
  }, [user?._id]);

  useEffect(() => {
    let canceled = false;
    if (!user?._id) {
      setAssessorEnviouPreliminar(false);
      setAssessorPreliminarSuperseded(false);
      setVpTemPreliminarPendente(false);
      return;
    }
    if (isAssessor) {
      fetchUltimoPreliminarByAssessor(user._id)
        .then((raw) => {
          if (canceled) return;
          // voto_preliminar_etapa3__c é compartilhado com a ELBB — só conta
          // se o preliminar pertencer ao produto Conexão.
          const p = isPreliminarConexao(raw?.notasRascunho) ? raw : null;
          setAssessorEnviouPreliminar(p?.status === 'em_aprovacao' && !p?.supersededAt);
          setAssessorPreliminarSuperseded(!!p?.supersededAt);
        })
        .catch(() => {
          if (canceled) return;
          setAssessorEnviouPreliminar(false);
          setAssessorPreliminarSuperseded(false);
        });
    } else if (isVp) {
      fetchPreliminarEmAprovacaoByVp(user._id, isPreliminarConexao)
        .then((p) => {
          if (!canceled) setVpTemPreliminarPendente(!!p);
        })
        .catch(() => {
          if (!canceled) setVpTemPreliminarPendente(false);
        });
    }
    return () => {
      canceled = true;
    };
  }, [user?._id, isAssessor, isVp]);

  useEffect(() => {
    if (comunicados.length > 0 && comunicados[0].steps.length > 1) {
      const startInterval = () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }

        if (!isCarouselPaused) {
          intervalRef.current = setInterval(() => {
            setStepAtivo((prev) => {
              const totalSteps = comunicados[0].steps.length;
              return (prev + 1) % totalSteps;
            });
          }, 5000);
        }
      };

      startInterval();

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [comunicados, isCarouselPaused]);

  useEffect(() => {
    async function checkEtapa1Completion() {
      if (!isElegivelEtapa1 || !user?.detail) return;
      const identifier = getIdentifierFromPlayerFields(user.detail);
      if (!identifier.comite && !identifier.prefixo) return;
      try {
        const etapa1 = (user.detail.etapa1 || []) as string[];

        const temMad = etapa1
          .map((v) => String(v).toUpperCase())
          .includes('MAD');
        const [iniciativasBase, iniciativasMad] = await Promise.all([
          buscarValidacaoEtapa1PorPrefixo(identifier),
          temMad
            ? buscarValidacaoEtapa1PorPrefixo(identifier, { category: 'MAD' })
            : Promise.resolve([] as Awaited<ReturnType<typeof buscarValidacaoEtapa1PorPrefixo>>),
        ]);
        const todasIniciativas = [
          ...(iniciativasBase || []),
          ...(iniciativasMad || []),
        ];
        setTemIniciativasEtapa1(todasIniciativas.length > 0);

        // Expande etapa1Key cobrindo o split JJ_HIBRIDO -> ECBB + ECBB_REDE,
        // que só existe quando há iniciativas com isRede no escopo do usuário.
        const categoriasVotacao = getCategoriasVotacao(etapa1, todasIniciativas).filter(
          (cat) => cat.isMad || filterIniciativasByCategoria(todasIniciativas, cat).length > 0
        );
        const expandedKeys = categoriasVotacao.map((c) => c.etapa1Key);
        if (expandedKeys.length === 0) {
          setTodasCategoriasEtapa1Completas(false);
          return;
        }
        const completadas = await fetchCategoriasCompletadas(identifier, expandedKeys);
        const completadasSet = new Set(completadas);
        setTodasCategoriasEtapa1Completas(
          expandedKeys.every((key) => completadasSet.has(key))
        );
      } catch {
        // best-effort
      }
    }
    if (isEtapaUmVotacaoAtiva && isElegivelEtapa1) {
      checkEtapa1Completion();
    }
  }, [isEtapaUmVotacaoAtiva, isElegivelEtapa1, user]);

  if (!user) return null;

  const getUserData = () => ({
    nome: user.detail?.nome_guerra || user.detail?.nome || user.name || 'Usuário',
    foto: user.image?.small?.url || ''
  });

  const handlePrevStep = () => {
    setStepAtivo((prev) => {
      const totalSteps = comunicados[0].steps.length;
      return prev === 0 ? totalSteps - 1 : prev - 1;
    });
  };

  const handleNextStep = () => {
    setStepAtivo((prev) => {
      const totalSteps = comunicados[0].steps.length;
      return (prev + 1) % totalSteps;
    });
  };

  const handleOpenOnboarding = () => {
    if (tutorial && tutorial.steps.length > 0) {
      showModal(
        'onboarding-modal',
        <OnboardingModal
          steps={tutorial.steps}
          onClose={closeModal}
        />,
        'onboarding-modal-wrapper',
        false
      );
    } else {
      console.warn('Tutorial não disponível');
    }
  };

  const handleOpenExperienciasVideo = () => {
    showModal(
      'experiencias-video',
      <div className="experiencias-video">
        <button
          type="button"
          className="experiencias-video__close"
          onClick={closeModal}
          aria-label="Fechar vídeo"
        >
          <IoClose size={24} aria-hidden="true" />
        </button>
        <video
          src={EXPERIENCIAS_VIDEO_URL}
          controls
          autoPlay
          playsInline
          className="experiencias-video-player"
        >
          Seu navegador não suporta a reprodução de vídeo.
        </video>
      </div>,
      'experiencias-video-wrapper',
      false
    );
  };

  const handleScrollToBadges = () => {
    if (!badgesSectionRef.current) {
      return;
    }

    const headerOffset = 110;
    const targetTop = badgesSectionRef.current.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });
  };

  const handleOpenVotingTutorial = (event?: MouseEvent<HTMLElement>) => {
    event?.stopPropagation();

    if (!phases.etapa1premio) return;

    if (!tutorialEtapa1?.steps?.length) {
      console.warn('Tutorial Etapa 1 não disponível');
      return;
    }

    showModal(
      'votacao-etapa1-tutorial-modal',
      <VotacaoEtapa1TutorialModal
        steps={tutorialEtapa1.steps}
        onClose={closeModal}
        onStartVoting={() => {
          closeModal();
          navigate('/votacao-etapa-1');
        }}
      />,
      'votacao-etapa1-tutorial-wrapper',
      false
    );
  };

  const handleGoToEtapaUmVotacao = () => {
    if (!phases.etapa1premio) return;
    navigate('/votacao-etapa-1');
  };

  const handleGoToEtapaDoisVotacao = () => {
    if (!phases.etapa2premio) return;
    navigate('/votacao-etapa-2');
  };

  const handleGoToEtapaTresVotacao = () => {
    navigate('/votacao-etapa-3');
  };

  const handleGoToMeusVotosEtapa3 = () => {
    navigate('/meus-votos-etapa-3');
  };

  const abrirTutorialEtapa2 = () => {
    if (!phases.etapa2premio) return;
    if (!tutorialEtapa2?.steps?.length) {
      handleGoToEtapaDoisVotacao();
      return;
    }
    showModal(
      'votacao-etapa2-tutorial-modal',
      <VotacaoEtapa2TutorialModal
        steps={tutorialEtapa2.steps}
        onClose={closeModal}
        onStartVoting={() => {
          closeModal();
          handleGoToEtapaDoisVotacao();
        }}
      />,
      'votacao-etapa2-tutorial-wrapper',
      false
    );
  };

  const abrirTutorialEtapa3 = () => {
    if (!phases.etapa3premio) return;
    if (!tutorialEtapa3?.steps?.length) {
      navigate('/votacao-etapa-3');
      return;
    }
    showModal(
      'votacao-etapa3-tutorial-modal',
      <VotacaoEtapa3TutorialModal
        steps={tutorialEtapa3.steps}
        onClose={closeModal}
        onStartVoting={() => { closeModal(); navigate('/votacao-etapa-3'); }}
      />,
      'votacao-etapa3-tutorial-wrapper',
      false
    );
  };

  return (
    <div id="home-public-wrapper">
      <Header
        currentPage="inicio"
        canAccessMinhasIniciativas={canAccessMinhasIniciativas}
        highlightMinhaJornada={ganhouPremio}
      />

      <NotificationPopup
        open={extratoPopupOpen && ganhouPremio}
        onClose={() => setExtratoPopupOpen(false)}
        title="Você já pode conferir seu extrato!"
        description="Acesse a página “Minha Jornada” e confira o seu extrato completo com a premiação das iniciativas classificadas na Etapa 1."
        actionLabel="VER EXTRATO"
        actionPath="/minha-jornada"
      />

      <Hero
        user={getUserData()}
        badges={loadingBadges ? [] : badges}
        isParticipanteConfirmado={isParticipanteConfirmado}
        hasConquistaVotar={hasConquistaVotar}
        ilustracao={navesHome}
        onOpenOnboarding={handleOpenOnboarding}
        onViewMoreBadges={handleScrollToBadges}
      />

      <main className="home-main">

        {etapasCronograma.length > 0 && (
          <section className="cronograma-section">
            <div className="cronograma-section__content">
              <h2 className="section-title">Acompanhe o cronograma</h2>
              <Timeline steps={etapasCronograma} />
            </div>
          </section>
        )}

        <PreInscricaoNotification situacao={situacaoPreInscricao} icone={avisoInscricao} />

        {isEtapaUmVotacaoAtiva && isElegivelEtapa1 && temIniciativasEtapa1 && todasCategoriasEtapa1Completas && (
        <section className="notification-banner notification-banner--votacao">
          <div
            className="notification-banner__content notification-banner__content--clickable"
            onClick={() => navigate('/meus-votos')}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                navigate('/meus-votos');
              }
            }}
          >
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            <p className="notification-banner__text">
              A seleção de iniciativas da Etapa 1 do Prêmio BB já foi concluída para o seu prefixo.
            </p>
            <button
              className="notification-banner__btn"
              onClick={(event) => {
                event.stopPropagation();
                navigate('/meus-votos');
              }}
            >
              VER SELEÇÃO
            </button>
          </div>
        </section>
        )}

        {isEtapaUmVotacaoAtiva && isElegivelEtapa1 && temIniciativasEtapa1 && !todasCategoriasEtapa1Completas && (
        <section className="notification-banner notification-banner--votacao">
          <div
            className="notification-banner__content notification-banner__content--clickable"
            onClick={handleGoToEtapaUmVotacao}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleGoToEtapaUmVotacao();
              }
            }}
          >
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            <p className="notification-banner__text">
              Você faz parte do comitê que seleciona as iniciativas na Etapa 1 do Prêmio BB.{' '}
              <button
                className="notification-banner__link"
                onClick={handleOpenVotingTutorial}
              >
                Saiba como fazer a seleção!
              </button>
            </p>
            <button
              className="notification-banner__btn"
              onClick={(event) => {
                event.stopPropagation();
                handleGoToEtapaUmVotacao();
              }}
            >
              INICIAR SELEÇÃO!
            </button>
          </div>
        </section>
        )}

        {(isEtapaUmVotacaoAtiva && !loadingIniciativas && isInscricaoAtiva && (temIniciativasParaInscrever || temIniciativasParaConfirmar)) && (
        <section className="notification-banner">
          <div className="notification-banner__content">
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            <p className="notification-banner__text">
              Você possui iniciativas para inscrição e/ou confirmação de participação!
            </p>
            <button
              className="notification-banner__btn"
              onClick={() => navigate('/listagem-inscricao-premio')}
            >
              VER INICIATIVAS
            </button>
          </div>
        </section>
        )}


         {/* {(!loadingIniciativas && !isInscricaoAtiva && temIniciativasParaConfirmar) && ( */}
        {(isEtapaUmVotacaoAtiva && !loadingIniciativas && !isInscricaoAtiva && temIniciativasParaConfirmar) && (
        <section className="notification-banner">
          <div className="notification-banner__content">
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            <p className="notification-banner__text">
              Você possui iniciativas para confirmar participação!
            </p>
            <button
              className="notification-banner__btn"
              onClick={() => navigate('/listagem-inscricao-premio')}
            >
              VER INICIATIVAS
            </button>
          </div>
        </section>
        )}

         {/* {(!loadingIniciativas && !temIniciativasParaInscrever && !temIniciativasParaConfirmar && isParticipanteConfirmado) && ( */}
        {(isEtapaUmVotacaoAtiva && !loadingIniciativas && !temIniciativasParaInscrever && !temIniciativasParaConfirmar && isParticipanteConfirmado) && (
        <section className="notification-banner">
          <div className="notification-banner__content">
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            <p className="notification-banner__text">
              Parabéns você está participando do Prêmio BB! Acompanhe a evolução das suas iniciativas.
            </p>
            <button
              className="notification-banner__btn"
              onClick={() => navigate('/minhas-iniciativas')}
            >
              MINHAS INICIATIVAS
            </button>
          </div>
        </section>
        )}

        {/* {temIndicacoesPendentesGE && (
        <section className="notification-banner notification-banner--votacao">
          <div className="notification-banner__content">
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            <p className="notification-banner__text">
              Você possui iniciativa(s) aguardando indicação dos 5 participantes que mais atuaram para o sucesso da entrega.
            </p>
            <button
              className="notification-banner__btn"
              onClick={() => navigate('/minhas-iniciativas')}
            >
              VER INICIATIVAS
            </button>
          </div>
        </section>
        )} */}

        {/* O banner de notificação de votação da Etapa 3 foi removido para adequação ao protótipo da fase de vencedores */}
        {isElegivelEtapa3 && (phases.etapa3premio || jaVotouTodasCategoriasEtapa3) && (
        <section className="notification-banner notification-banner--votacao notification-banner--etapa3">
          <div
            className="notification-banner__content notification-banner__content--clickable"
            onClick={jaVotouTodasCategoriasEtapa3 ? handleGoToMeusVotosEtapa3 : handleGoToEtapaTresVotacao}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                (jaVotouTodasCategoriasEtapa3 ? handleGoToMeusVotosEtapa3 : handleGoToEtapaTresVotacao)();
              }
            }}
          >
            <img
              src={avisoInscricao}
              alt=""
              aria-hidden="true"
              className="notification-banner__icon"
            />
            {jaVotouTodasCategoriasEtapa3 && !isAssessor ?  (
              <p className="notification-banner__text">
                Seu voto foi registrado na Etapa 3.
              </p>
            ) : isAssessor ? (
              <p className="notification-banner__text">
                {assessorPreliminarSuperseded
                  ? 'O voto final da Etapa 3 já foi enviado pelo seu Vice-Presidente.'
                  : assessorEnviouPreliminar
                  ? 'Voto preliminar enviado — aguardando a revisão do Vice-Presidente.'
                  : 'Você está com um perfil de Assessor e pode preparar o voto preliminar da Etapa 3 para o seu Vice-Presidente/Presidente.'}{' '}
                {!assessorJaEnviou && (
                  <button
                    type="button"
                    className="notification-banner__link"
                    onClick={(event) => {
                      event.stopPropagation();
                      abrirTutorialEtapa3();
                    }}
                  >
                    Saiba aqui como votar!
                  </button>
                )}
              </p>
            ) : (
              <p className="notification-banner__text">
                {isVp && vpTemPreliminarPendente
                  ? 'Seu Assessor preparou um voto preliminar para a sua revisão.'
                  : 'Você faz parte da banca avaliadora!'}
                {datasEtapa3Label
                  ? ` A votação da Etapa 3 acontece de ${datasEtapa3Label}. `
                  : ''}
                <button
                  type="button"
                  className="notification-banner__link"
                  onClick={(event) => {
                    event.stopPropagation();
                    abrirTutorialEtapa3();
                  }}
                >
                  Saiba aqui como votar!
                </button>
              </p>
            )}
            {/* <button
              className="notification-banner__btn"
              onClick={(event) => {
                event.stopPropagation();
                if (assessorJaEnviou) {
                  handleGoToEtapaTresVotacao();
                } else if (jaVotouTodasCategoriasEtapa3) {
                  handleGoToMeusVotosEtapa3();
                } else {
                  handleGoToEtapaTresVotacao();
                }
              }}
            >
              {assessorJaEnviou
                ? 'VER VOTO PRELIMINAR'
                : jaVotouTodasCategoriasEtapa3 && !isAssessor
                ? 'VER MEUS VOTOS'
                : 'INICIAR VOTAÇÃO!'}
            </button> */}
          </div>
        </section>
        )}

        {user?.extra?.etapa === 2 && phases.etapa2premio && user?.extra?.categories?.some((c: string) => c !== 'ELBB') && (
        <section className="notification-banner notification-banner--votacao">
          <div
            className="notification-banner__content notification-banner__content--clickable"
            onClick={handleGoToEtapaDoisVotacao}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleGoToEtapaDoisVotacao();
              }
            }}
          >
            <img src={avisoInscricao} alt="" aria-hidden="true" className="notification-banner__icon" />
            {jaVotouTodasCategoriasEtapa2 ? (
              <p className="notification-banner__text">
                Sua avaliação da Etapa 2 foi enviada. Confira aqui suas notas.
              </p>
            ) : (
              <p className="notification-banner__text">
                Você faz parte da banca técnica que avalia as iniciativas na Etapa 2 do Prêmio BB.
                {datasEtapa2Label && ` A votação da Etapa 2 acontece de ${datasEtapa2Label}.`}{' '}
                <button
                  className="notification-banner__link"
                  onClick={(event) => {
                    event.stopPropagation();
                    abrirTutorialEtapa2();
                  }}
                >
                  Saiba aqui como votar!
                </button>
              </p>
            )}
            <button
              className="notification-banner__btn"
              onClick={(event) => {
                event.stopPropagation();
                handleGoToEtapaDoisVotacao();
              }}
            >
              {jaVotouTodasCategoriasEtapa2 ? 'VER AVALIAÇÃO' : 'INICIAR VOTAÇÃO!'}
            </button>
          </div>
        </section>
        )}

        <div className="categorias-participantes-wrapper">
          <CategoriasParticipantes variant="etapa3" title="Conheça as iniciativas vencedoras do Prêmio BB 2026" />
        </div>

        <section className="premiacoes-section">
          <h2 className="premiacoes-section__title" tabIndex={0}>Conheça as premiações</h2>
          <div className="premiacoes-grid">

            {/* Card 1: Experiências BB — PNG (avião + estrelas) usado como background */}
            <div
              className="premiacao-card premiacao-card--aviao"
              style={{ backgroundImage: `url(${aviaoPremiacao})` }}
              tabIndex={0}
              aria-label="Ilustração do prêmio Experiências BB"
            >
              <div className="premiacao-card__body premiacao-card__body--right">
                <h3 className="premiacao-card__title" tabIndex={0}>Prêmio Individual Experiências BB</h3>
                <p className="premiacao-card__description" tabIndex={0}>
                  Viagem nacional, com acompanhante, com direito a uma <br></br> experiência marcante e especial com a marca BB. <br />
                </p>
                <button
                  type="button"
                  className="premiacao-card__btn"
                  onClick={handleOpenExperienciasVideo}
                >
                  Conheça as experiências
                </button>
              </div>
            </div>

            {/* Card 2: Cartão Premiação — PNG (cartão + estrelas) usado como background */}
            <div
              className="premiacao-card premiacao-card--cartao"
              style={{ backgroundImage: `url(${cartaoPremiacao})` }}
              tabIndex={0}
              aria-label="Ilustração do cartão premiação na modalidade pré-pago"
            >
              <div className="premiacao-card__body premiacao-card__body--left">
                <h3 className="premiacao-card__title" tabIndex={0}>Cartão premiação na modalidade pré-pago</h3>
                <p className="premiacao-card__description" tabIndex={0}>
                  Para todos os participantes das iniciativas premiadas:<br />
                  <strong>1º lugar:</strong> R$ 3 mil • <strong>2º lugar:</strong> R$ 2 mil • <strong>3º lugar:</strong> R$ 1,2 mil
                </p>
              </div>
            </div>

          </div>
        </section>

        {/* <GaleriaPremio /> */}

        {/* <section className="comunicados-section">
          <h2 className="section-title">Comunicados</h2>
          <div className="comunicados-container">
            {loadingComunicados ? (
              <div className="flex justify-center items-center py-8">
                <span className="text-blue-bb">Carregando comunicados...</span>
              </div>
            ) : comunicados.length > 0 && comunicados[0].steps.length > 0 ? (
              <div
                className="comunicado-carrossel"
                onMouseEnter={() => setIsCarouselPaused(true)}
                onMouseLeave={() => setIsCarouselPaused(false)}
              >
                <div className="comunicado-stage">
                  <button
                    className="carousel-arrow carousel-arrow--prev"
                    onClick={handlePrevStep}
                    aria-label="Comunicado anterior"
                  >
                    <IoChevronBack size={32} />
                  </button>

                  {(() => {
                    const currentStep = comunicados[0].steps[stepAtivo];
                    return (
                      <ComunicadoBanner
                        html={currentStep?.text || ''}
                      />
                    );
                  })()}

                  <button
                    className="carousel-arrow carousel-arrow--next"
                    onClick={handleNextStep}
                    aria-label="Próximo comunicado"
                  >
                    <IoChevronForward size={32} />
                  </button>
                </div>

                <div className="carousel-dots">
                  {comunicados[0].steps.map((_: any, index: number) => (
                    <button
                      key={index}
                      className={`carousel-dot ${index === stepAtivo ? 'active' : ''}`}
                      onClick={() => setStepAtivo(index)}
                      aria-label={`Ver comunicado ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="comunicado-carrossel">
                <p className="text-center text-gray-500 py-8">Nenhum comunicado disponível no momento.</p>
              </div>
            )}

            <div className="premio-card">
              <div className="premio-card__inner">
                <p className="premio-card__subtitle">Conheça também as</p>
                <p className="premio-card__subtitle">iniciativas do</p>
                <div className="premio-card__logo">
                  <img src={premioElbb} alt="Prêmio ELBB" />
                </div>
                <button className="premio-card__button" onClick={() => navigate('/login-elbb')}>QUERO CONHECER!</button>
              </div>
            </div>
          </div>
        </section> */}

        {/* <section className="cta-section">
          <div className="cta-card cta-card--yellow" onClick={() => navigate('/iniciativas')} style={{ cursor: 'pointer' }}>
            <div className="cta-card__content">
              <h3 className="cta-card__title">Explorar iniciativas</h3>
              <p className="cta-card__subtitle">Conheça as iniciativas inspiradoras</p>
            </div>
            <button className="cta-card__btn">
              <IoArrowForward size={28} />
            </button>
          </div>
          <div className="cta-card cta-card--pink" onClick={() => navigate('/minha-jornada')} style={{ cursor: 'pointer' }}>
            <div className="cta-card__content">
              <h3 className="cta-card__title">Minha jornada</h3>
              <p className="cta-card__subtitle">Complete desafios e ganhe badges</p>
            </div>
            <button className="cta-card__btn">
              <IoArrowForward size={28} />
            </button>
          </div>
        </section> */}

        <section className="badges-section" ref={badgesSectionRef}>
          <h2 className="section-title">Coleção de badges</h2>
          {loadingBadges ? (
            <div className="flex justify-center items-center py-8">
              <span className="text-blue-bb">Carregando badges...</span>
            </div>
          ) : (
            <div className="badges-container">
              <div className="badges-grid">
                {badges.map((badge) => (
                  <div
                    key={badge.id}
                    className={`badge-item ${badge.conquistado ? 'conquistado' : 'bloqueado'}`}
                  >
                    {badge.conquistado && <span className="badge-check" aria-hidden="true">✓</span>}
                    <img src={badge.imagem} alt="" aria-hidden="true" className="badge-image" />
                    <p className="badge-nome">{badge.nome}</p>
                    <span className="sr-only">{badge.conquistado ? 'Conquistado' : 'Bloqueado'}</span>
                  </div>
                ))}
              </div>
              <button className="btn-ver-todos" onClick={() => navigate('/minha-jornada#badges')}>VER TODOS</button>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}
